import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Space, Tag } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoEyeOutline } from "react-icons/io5";

const JournalCard = ({ imageSrc, title, dropdownItems, tags, date, views }) => {
  return (
    <div className="card journal-card">
      <img src={imageSrc} alt="" />
      <div className="journal-card-content">
        <div className="journal-card-header">
          <h3>{title}</h3>
          <Dropdown
            trigger={["click"]}
            menu={{
              items: dropdownItems,
            }}
            placement="bottomLeft"
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <BsThreeDotsVertical />
              </Space>
            </a>
          </Dropdown>
        </div>
        <div>
          {tags.map((tag, index) => (
            <Tag key={index}>{tag}</Tag>
          ))}
        </div>
        <div className="journal-card-footer">
          <h6 className="disactive">{date}</h6>
          <h6 className="">
            {views} <IoEyeOutline />
          </h6>
        </div>
      </div>
    </div>
  );
};

// Define PropTypes for validation
JournalCard.propTypes = {
  imageSrc: PropTypes.string.isRequired, // Image URL
  title: PropTypes.string.isRequired, // Card title
  dropdownItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired, // Dropdown menu items
  tags: PropTypes.arrayOf(PropTypes.string).isRequired, // Tags array
  date: PropTypes.string.isRequired, // Date string
  views: PropTypes.number.isRequired, // Number of views
};

export default JournalCard;
